import axios from 'axios'

let BASE_URL = ''
let API_URL = ''
let APP_URL = ''
let API_BASE_URL = ''

if (location.hostname == 'localhost') {
    BASE_URL = 'http://localhost:8080/'
    API_URL = 'http://127.0.0.1:8000/api/'
    APP_URL = 'http://deh_diqcare_sk.local/'
    API_BASE_URL = 'http://127.0.0.1:8000/'

// } else {
//     BASE_URL = 'https://sk-app-up.dristieyehospital.com/'
//     API_URL = 'https://sk-api-up.dristieyehospital.com/api/'
//     API_BASE_URL = 'https://sk-api-up.dristieyehospital.com/'
//     APP_URL = 'https://sk-up.dristieyehospital.com/'
// }
} else {
    BASE_URL = 'https://sk-app.doctuch.com/'
    API_URL = 'https://sk-api.doctuch.com/api/'
    API_BASE_URL = 'https://sk-api.doctuch.com/'
    APP_URL = 'https://sk.doctuch.com/'
}


const axiosAdmin = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
})
axiosAdmin.defaults.headers.common['base_URL'] = BASE_URL;
axiosAdmin.defaults.headers.common['api_URL'] = API_URL;
axiosAdmin.defaults.headers.common['api_base_URL'] = API_BASE_URL;
axiosAdmin.defaults.headers.common['app_URL'] = APP_URL;
axiosAdmin.defaults.headers.common['Authorization'] = localStorage.getItem("token");
export default axiosAdmin